define('modules/accounts/status/products/landings/view',['require','exports','module','views/BaseView','views/ProgressBarView','env','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var ProgressBarView = require("views/ProgressBarView");
  var Config = require("env");

  var View = BaseView.extend({
    template: require("ldsh!./template"),
    initialize: function () {
      if (this.model) {
        this.listenTo(this.model, "sync request error", this.render);
      }
    },
    beforeRender: function () {
      this.insertView(
        "#companies-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.COMPANIES_PROGRESS_BAR",
          num: this.group.getNumCompanies("landings"),
          max: this.group.getMaxCompanies("landings"),
        })
      );
      this.insertView(
        "#users-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.USERS_PROGRESS_BAR",
          num: this.group.getNumUsers("landings"),
          max: this.group.getMaxUsers("landings"),
        })
      );
      this.insertView(
        "#visits-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.LANDINGS.LBL_NUM_VISITS_PROGRESS",
          num: this.model.get("numVisitors"),
          max: this.group.getService("landings").properties.maxVisits,
        })
      );
      this.insertView(
        "#domains-progress-bar",
        new ProgressBarView({
          title: "ACCOUNTS.STATUS.LANDINGS.LBL_NUM_DOMAINS_PROGRESS",
          num: this.model.get("numDomains"),
          max: this.group.getService("landings").properties.maxDomains,
        })
      );
    },

    serialize: function () {
      return {
        group: this.group,
        model: this.model,
        servicePlan: this.group.getService("landings").type,
        daysToExpiration: this.group.getDaysToExpiration("landings"),
        landingsUrl: Config.landingsUrl,
        paymentsUrl:
          Config.paymentsUrl + "account/products" + Config.getCompanyIdForUrl(),
      };
    },
  });

  module.exports = View;
});

